





















import { Component, Prop, Vue } from "vue-property-decorator";
import ContactForm from "@/components/ContactForm.vue";

import contactSectionSVG from "@/assets/images/contact-rings.svg?inline";

@Component({
  components: {
    ContactForm,
    contactSectionSVG,
  }
})
export default class ContactSection extends Vue {
  @Prop() private interludeText!: string;
  @Prop() private headingTextLine1!: string;
  @Prop() private headingTextLine2!: string;
  @Prop() private contactUsButtonText!: string;

  showContactForm: boolean = false;
  onContactButtonClick() {
    this.showContactForm = true;
    Vue.prototype.common.appScrollTo("#contact-section");
    document.body.classList.add("noscroll");
  }

  exitForm() {
    this.showContactForm = false;
    document.body.classList.remove("noscroll");
  }

  mounted() {
    // Animate Background Rings 
    // NOTE: something is wrong with path points for ring_1.
    // consider reworking SVG files, but not animating works visually more
    // thus, we are not animating ring_1
    const duration: number = 10000;
    Vue.prototype.$anime({
      targets: "#ring_2",
      d: [
        { value: document.getElementById("ring_3").getAttribute("d") },
        { value: document.getElementById("ring_2").getAttribute("d") },
      ],
      // direction: 'alternate',
      easing: "linear",
      duration: duration,
      loop: true
    });
    Vue.prototype.$anime({
      targets: "#ring_3",
      d: [
        { value: document.getElementById("ring_4").getAttribute("d") },
        { value: document.getElementById("ring_3").getAttribute("d") },
      ],
      // direction: 'alternate',
      easing: "linear",
      duration: duration,
      loop: true
    });
    Vue.prototype.$anime({
      targets: "#ring_4",
      d: [
        { value: document.getElementById("ring_2").getAttribute("d") },
        { value: document.getElementById("ring_4").getAttribute("d") },
      ],
      // direction: 'alternate',
      easing: "linear",
      duration: duration,
      loop: true
    });

    (<any> window).contactFormResize = Vue.prototype.$_.debounce(this.contactFormResize, 1000);
    window.addEventListener("resize", (<any> window).contactFormResize);
  }

  beforeDestroy() {
    document.body.classList.remove("noscroll");

    window.removeEventListener("resize", (<any> window).contactFormResize);
    (<any> window).contactFormResize = undefined;
  }

  contactFormResize() {
    if (this.showContactForm) {
      Vue.prototype.common.appScrollTo("#contact-section");
    }
  }
}
